

import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import { getFormNaturalezasLesion } from "../../../../../actions/forms";
import FormikAutocomplete from "../../../../commons/formik/formikAutocomplete";

const NaturalezaLesionControl = ({ disabled, updateFilteredZonasAfectadas, updateFilteredNaturalezasLesion, naturalezasLesion, required, artId, callBack, ...props }) => {
  const { values, setFieldValue } = useFormikContext();
  const dispatch = useDispatch();
  return (
    <FormikAutocomplete
      name="naturalezaLesion"
      label={`Naturaleza de la Lesión ${required ? "*" : ""
        }`}
      variant="outlined"
      callBack={(value) => {
        let newZonasAfectadasOptions = updateFilteredZonasAfectadas(values.diagnosticoOMS, value?.id);
        if (!newZonasAfectadasOptions.some((zona) => zona.id === values.zonaAfectada)) {
          setFieldValue('zonaAfectada', null);
        }
        if (callBack) callBack(value);
      }}
      getOptions={() => dispatch(getFormNaturalezasLesion(artId))}
      options={naturalezasLesion}
      disabled={disabled}
      {...props}
    />
  )
};

export default NaturalezaLesionControl;